import {Routes, Route, Link, useLocation, useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import {Loading} from '../../../../../_metronic/elements/Loading'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useIsMobile} from '../../../../shared/responsive'
import CreateEconomicReport from './CreateEconomicReport'
import ViewEconomicReport from './ViewEconomicReport'
import Report from './Report'
import {useEconomicReportContext} from './EconomicReportContext'
import './EconomicReport.scss'

const EconomicReport = () => {
  const {t} = useTranslation()
  const {loading, reports} = useEconomicReportContext()
  const navigate = useNavigate()
  const location = useLocation()
  const isMobile = useIsMobile()
  const isCreateMobile = location.pathname === '/gis/reports/economic/new'
  const isViewMobile = location.pathname.startsWith('/gis/reports/economic/view/')

  const nestedRoutes = (
    <Routes>
      <Route path='new' element={<CreateEconomicReport />} />
      <Route path='view/:id' element={<ViewEconomicReport />} />
    </Routes>
  )

  const mobileList =
    isMobile && !isCreateMobile && !isViewMobile ? (
      <div className='reports-mobile-shell displayable'>
        <div className='card shadow-sm right-card-data reports-mobile-card'>
          <div className='reports-mobile-card__header'>
            <button
              type='button'
              className='btn btn-sm btn-light reports-mobile-card__back'
              onClick={() => navigate('/gis/reports')}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon svg-icon-2' />
              <span>{t('common:navigation.back_reports')}</span>
            </button>
            <div className='reports-mobile-card__eyebrow'>
              {t('reports:selector.report_label')}
            </div>
            <h2 className='reports-mobile-card__title'>
              {t('reports:selector.economic_report')}
            </h2>
            <button
              type='button'
              className='btn btn-sm btn-primary reports-mobile-card__primary-action'
              onClick={() => navigate('/gis/reports/economic/new')}
            >
              {t('reports:economic.list.buttons.create')}
            </button>
          </div>
          <div className='reports-mobile-card__body'>
            {loading && (
              <div className='reports-mobile-card__state'>
                <Loading />
              </div>
            )}
            {!loading && reports.length < 1 && (
              <div className='reports-mobile-card__empty'>
                {t('reports:economic.list.no_reports')}
              </div>
            )}
            {!loading && reports.map((report) => <Report key={report.id} report={report} />)}
          </div>
        </div>
      </div>
    ) : null

  const desktopList = !isMobile ? (
    <div className='card shadow-sm field-view-container displayable right-card-data ndvi-report-list-card economic-report-list-card'>
      <div className='card-header collapsible ndvi-report-list-card__header'>
        <div className='ndvi-report-list-card__heading'>
          <button
            type='button'
            className='btn btn-sm btn-light reports-mobile-card__back ndvi-report-list-card__back'
            onClick={() => navigate('/gis/reports')}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon svg-icon-2' />
            <span>{t('common:navigation.back_reports')}</span>
          </button>
          <h4
            className='card-title cursor-pointer ndvi-report-list-card__title'
            data-bs-toggle='collapse'
            data-bs-target='#kt_economic_report_list'
          >
            {t('reports:selector.economic_report')}
          </h4>
        </div>
        <div className='card-toolbar'>
          <Link
            to='/gis/reports/economic/new'
            className='btn btn-sm btn-light-primary gis-toolbar-action'
          >
            {t('reports:economic.list.buttons.create')}
          </Link>
        </div>
      </div>
      <div id='kt_economic_report_list' className='collapse show'>
        <div className={'card-body ' + (reports.length < 1 || loading ? 'p-5' : 'p-0')}>
          {loading && <Loading />}
          {!loading && reports.length < 1 && (
            <p className='m-0 reports-empty-state'>{t('reports:economic.list.no_reports')}</p>
          )}
          {reports.map((report) => (
            <Report key={report.id} report={report} />
          ))}
        </div>
      </div>
    </div>
  ) : null

  return (
    <>
      {mobileList}
      {desktopList}
      {nestedRoutes}
    </>
  )
}

const EconomicReportModule = () => (
  <div className='d-flex flex-column flex-row-auto field-view-flex-container'>
    <div className='d-flex flex-column-auto'>
      <EconomicReport />
    </div>
  </div>
)

export default EconomicReportModule
